import React from "react";
import AlertContainer from "alerts/alert_summary/AlertContainer";

class AlertList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		let alertList = Object.keys(this.props.alerts).map((companyName) => {
			let alerts = this.props.alerts[companyName];
			return (
				<React.Fragment key={companyName}>
					<AlertContainer
						{...this.props}
						alerts={alerts}
						companyName={companyName}
					/>
				</React.Fragment>
			);
		});
		return (
			<>
				{alertList.length > 0 ? (
					<div className="alert-list d-flex justify-content-between">
						{alertList}
					</div>
				) : (
					<div style={{padding: "15px"}}>
						No alerts for this time period
					</div>
				)}
			</>
		);
	}
}

export default AlertList;
